import { render } from "./demo.vue?vue&type=template&id=367b2d1c"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/games/game.xiaofei.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__